'use client';

const ips = [
  { ip: '185.220.101.47', country: 'RU', events: 1847, type: 'Tor Exit Node' },
  { ip: '45.133.1.57', country: 'CN', events: 934, type: 'Known Scanner' },
  { ip: '103.75.246.18', country: 'IN', events: 721, type: 'VPS Hosting' },
  { ip: '91.108.4.23', country: 'UA', events: 612, type: 'Botnet C2' },
  { ip: '198.51.100.8', country: 'US', events: 441, type: 'Anonymous Proxy' },
];

const max = Math.max(...ips?.map((i) => i?.events));

export default function TopSourceIPs() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-200">En Büyük Tehdit Kaynakları</h3>
        <span className="text-[10px] text-zinc-600 uppercase tracking-wide">Bugün</span>
      </div>
      <div className="space-y-2.5">
        {ips?.map((ip, i) => (
          <div key={ip?.ip}>
            <div className="flex items-center justify-between mb-1">
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-bold text-zinc-600 w-4">{i + 1}</span>
                <span className="font-mono text-xs text-amber-400">{ip?.ip}</span>
                <span className="text-[10px] bg-zinc-800 text-zinc-500 px-1 rounded font-mono">{ip?.country}</span>
              </div>
              <span className="font-mono text-xs text-zinc-400 tabular-nums">{ip?.events?.toLocaleString('en-US')}</span>
            </div>
            <div className="h-1 bg-zinc-800 rounded-full overflow-hidden">
              <div
                className="h-full bg-rose-500/60 rounded-full"
                style={{ width: `${(ip?.events / max) * 100}%` }}
              />
            </div>
            <p className="text-[10px] text-zinc-600 mt-0.5">{ip?.type}</p>
          </div>
        ))}
      </div>
    </div>
  );
}